<ejs-dialog id="ejDialogAddEdit" #ejDialogAddEdit showCloseIcon='true' header='{{btnText}} {{customProjectNaming.level2Name}} Type'
    (beforeClose)="onDialogClose($event)" width="375" [visible]="isVisible" [animationSettings]='animationSettings'
    [target]="dialogDragTarget" [allowDragging]='allowDialogDragging' [enableResize]='false' isModal="true">
    <div>
        <div *ngIf="isLoading"><img class="loading-img" src="/assets/images/loading.gif"></div>
        <div *ngIf="!isLoading">
            <div class="center">
                
                    <mat-form-field appearance="outline" class="">
                        <mat-label>{{customProjectNaming.level2Name}} Type</mat-label>
                        <input #txtIncidentType matInput placeholder="eg: IP Theft" minlength="1"
                            maxlength="30"
                            [(ngModel)]="incidentType" />
                    </mat-form-field>

                    
            </div>

            <div style="padding: 10px;"></div>
            <div class="buttonSection center">
                <button ejs-button class="cancel" type="button" (click)="Cancel()">Cancel</button>
                <button class="success" id="btnSubmit" #btnSubmit
                    [disabled]="incidentType == ''"
                    (click)="AddUpdateIncidentType()"><img
                        src="/assets/images/progress-spinner.gif" class="button-spinner"
                        *ngIf="showUpdatingSpinner" />{{btnText}} {{customProjectNaming.level2Name}} Type</button>
            </div>
            
        </div>
    </div>
</ejs-dialog>